<template>
  <div>
    <v-row justify="end" class="my-4">
      <v-col cols="auto">
        <v-btn
          v-if="hasPerm('FUN_CONSULTA_SALDO_INSPIRUM')"
          class="common-botton mr-2"
          dark
          @click="getInspirumBalanceMethod"
        >
          Consultar saldo Inspirium
        </v-btn>

        <v-btn
          v-if="hasPerm('FUN_CREAR_SOLICITUD_REDENCION')"
          class="common-botton mr-2"
          dark
          @click="createNewRedencion"
        >
          <v-icon class="mr-2">mdi-plus-circle</v-icon>
          Crear redención asistencia
        </v-btn>

        <v-btn
          v-if="hasPerm('FUN_CREAR_SOLICITUD_REDENCION')"
          class="common-botton"
          dark
          @click="newSolicitud"
        >
          <v-icon class="mr-2">mdi-plus-circle</v-icon>
          Crear solicitud
        </v-btn>
      </v-col>
    </v-row>

    <FilterSolicitudes
      @searchUpdated="onSearchUpdated"
      :currentFilters="filtros"
      :loading="loading"
    />

    <hr />

    <TableSolicitudes
      :loading="loading"
      :solicitudes="solicitudes"
      :total-items="total_items"
      :pagination="pagination"
      @update:pagination="onPaginationChange"
      @seleccionSolicitud="seleccionSolicitud"
      @showDetails="showDetailSolicitud"
    />

    <CrearRedencion
      :solicitud="solicitud"
      :show="showModal"
      @close="cancelModal('redencion')"
      :showActions="showActions"
      :mode="mode"
      :lockedTipo="tipoRedencion"
    />

    <CrearSolicitud
      :solicitud="solicitud"
      :show="showModalSoli"
      @close="cancelModal('general')"
      :mode="mode"
      :ignoreClientStep="true"
    />
  </div>
</template>

<script>
import FilterSolicitudes from "@/components/solicitudes/FilterSolicitudes.vue";
import TableSolicitudes from "@/components/solicitudes/TableSolicitudes.vue";
import CrearRedencion from "@/components/solicitudes/modals/CrearRedencion.vue";
import CrearSolicitud from "@/components/solicitudes/modals/CrearSolicitud.vue";

import { mainAxios } from "@/mainAxios.js";
import { getSolicitudesByFilters } from "@/services/solicitudService";
import { getIspiriumBalance } from "@/services/InspiriumService.js";
import { mapState } from "vuex";

export default {
  components: {
    FilterSolicitudes,
    TableSolicitudes,
    CrearRedencion,
    CrearSolicitud,
  },

  data() {
    return {
      switch_data: 1,
      solicitudes: [],
      solicitud: {},
      filtros: {},
      loading: false,
      total: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      total_items: 0,
      showModal: false,
      showModalSoli: false,
      showActions: false,
      mode: "",
      solictiud: {},
      tipoRedencion: null,
    };
  },

  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
  },

  computed: {
    ...mapState("permisos", ["permisos"]),
  },

  methods: {
    async getSolicitudes(filtros = this.filtros) {
      const body = {
        ...filtros,
        pagina: this.pagination.page,
        registrosPagina: this.pagination.itemsPerPage,
      };
      try {
        this.solicitudes = [];
        this.loading = true;
        const response = await getSolicitudesByFilters(body);
        this.solicitudes = this.procesarSolicitudes(response.solicitudes);
        this.total_items = response.totalRegistros;
      } catch (error) {
        console.error("Error al obtener solicitudes:", error);
        this.$toast.error("No se pudieron cargar las solicitudes");
      } finally {
        this.loading = false;
      }
    },

    procesarSolicitudes(solicitudes) {
      return solicitudes.map((s) => ({
        ...s,
        nombre: `${s.nombre || ""} ${s.apellidoPaterno ||
          ""} ${s.apellidoMaterno || ""}`.trim(),
      }));
    },

    onPaginationChange(newPagination) {
      this.pagination = newPagination;
      this.getSolicitudes();
    },

    onSearchUpdated(newFilters) {
      this.filtros = { ...newFilters };
      this.pagination.page = 1;
      this.getSolicitudes();
    },

    getTodasLasSolicitudes() {
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get(`/v1/solicitud/info/status/1`, requestConfig)
        .then(({ data }) => {
          this.todasLasSolicitudes = data;
        });
    },

    seleccionSolicitud(val) {
      this.$emit("seleccionSolicitud", val);
    },
    createNewRedencion() {
      this.solicitud = {};
      this.showModal = true;
      this.showActions = false;
      this.mode = "create";
      this.tipoRedencion = "Redención Asistencia";
    },
    newSolicitud() {
      this.solicitud = {};
      this.showModalSoli = true;
      this.mode = "create";
    },
    showDetailSolicitud(solicitud) {
      this.mode = "view";
      if (
        solicitud.tipo == "Redención Beneficio" ||
        solicitud.tipo == "Redención Asistencia"
      ) {
        this.showActions = true;
        this.tipoRedencion = null;
        this.showModal = true;
      } else {
        this.showModalSoli = true;
      }

      this.solicitud = solicitud;
    },
    cancelModal(type) {
      if (type === "redencion") {
        this.showModal = false;
        this.solicitud = {};
      } else if (type === "general") {
        this.showModalSoli = false;
        this.solicitud = {};
      }
    },
    async getInspirumBalanceMethod() {
      const response = await getIspiriumBalance();
      this.$toast.info(
        "El saldo restante es de: " + this.formatCurrency(response.balance)
      );
    },
    formatCurrency(amount) {
      return amount.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
    hasPerm(perm) {
      return this.permisos?.includes(perm);
    },
  },
};
</script>

<!-- DEPRECATED -->

<!-- <template>
  <v-app>
    <v-row class="mb-10" dense align="center">
      <v-img
        :max-height="width_log2"
        :max-width="height_log2"
        :src="logo_2"
      ></v-img>
      <h2 class="ml-5">Solcitudes</h2>
      <v-spacer />
    </v-row>
    <v-row>
      <v-row v-if="permisos && permisos.includes('FUN_CONSULTA_SALDO_INSPIRUM')">
        <v-col cols="12" style="text-align: end; padding-right: 24px;">
          <v-btn
            color="primary"
            style="align-items: right"
            class="ml-11 mt-2"
            @click="getInspirumBalanceMethod"
          >
            Consultar saldo Inspirium
          </v-btn>
          <v-btn
            color="primary"
            @click="(showCreateModal = true), (route = '/v1/solicitud/manual')"
            style="align-items: right"
            class="ml-11 mt-2"
          >
            Crear
          </v-btn>
        </v-col>
      </v-row>
      <v-col cols="12">
        <BuscarSolicitud />
      </v-col>
    </v-row>
    <solicitudDialogForm
      :show="showCreateModal"
      @close="showCreateModal = false"
      :route="route"
    ></solicitudDialogForm>
  </v-app>
</template>

<script>
import BuscarSolicitud from "./BuscarSolicitud.vue";

import LogoSegurify from "@/assets/intermx-1.svg";
import LogoBradescard from "@/assets/logo-bradescard-horizontal.png";
import solicitudDialogForm from "@/components/solicitudes/solicitudDialogForm.vue";
import { getIspiriumBalance } from "@/services/InspiriumService.js";
import { mapState } from 'vuex';
export default {
  components: {
    BuscarSolicitud,
    solicitudDialogForm,
  },
  data() {
    return {
      logo_1: LogoSegurify,
      width_log1: 170,
      height_log1: 170,
      logo_2: LogoBradescard,
      width_log2: 80,
      height_log2: 250,
      showCreateModal: false,
      route: "",
      showInspiriumBalanceModal: false,
    };
  },
  computed: {
    ...mapState('permisos', ['permisos']),
    widthLogoSeg() {
      if (this.$vuetify.breakpoint.smAndDown) return "50";
      if (this.$vuetify.breakpoint.mdAndDown) return "50";
      return "80";
    },
    currentRol() {
      let roles = [];
      let CurrentRoles = JSON.parse(localStorage.getItem("roles"));
      CurrentRoles.forEach((element) => {
        if (element.rol != null) {
          roles.push(element.rol);
        }
      });

      if (roles.length > 0) {
        return roles[0];
      } else {
        return "";
      }
    },
  },
  methods: {
    leadCreado() {
      this.showCreacion = false;
      this.bus.$emit("reload");
    },
    async getInspirumBalanceMethod() {
      const response = await getIspiriumBalance();
      this.$toast.info(
        "El saldo restante es de: " + this.formatCurrency(response.balance)
      );
    },
    formatCurrency(amount) {
      return amount.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
  },
};
</script> -->
